// Author Liang Gang Qiang
// Date 2021-10-15 09:54:24

class ImfMstLocationShiftRule {
constructor({
        id = null,
        mstLocationId = '',
        mstShiftRuleId = '',
        beginDate = '',
        remark = ''}
= {}) {
    this.id = id;
    this.mstLocationId = mstLocationId;
    this.mstShiftRuleId = mstShiftRuleId;
    this.beginDate = beginDate;
    this.remark = remark;
}
}

function newEntity() {
return new ImfMstLocationShiftRule();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.imfMstLocationShiftRule.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstLocationName',
        label: 'label.em.admin.imfMstLocationShiftRule.grid.mstLocationName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftRuleName',
        label: 'label.em.admin.imfMstLocationShiftRule.grid.mstShiftRuleName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftRuleType',
        label: 'label.em.admin.imfMstLocationShiftRule.grid.mstShiftRuleType',
        sortable: true,
        form: {
        type: 'select'
        ,options: [
                { value: '1', text: '节假日休息' },
                            { value: '2', text: '节假日不休息' }
            ]
        }
        },
        {
        key: 'mstShiftRuleLoopRule',
        label: 'label.em.admin.imfMstLocationShiftRule.grid.mstShiftRuleLoopRule',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftRuleSwitchingCycle',
        label: 'label.em.admin.imfMstLocationShiftRule.grid.mstShiftRuleSwitchingCycle',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftRuleEachShiftDuration',
        label: 'label.em.admin.imfMstLocationShiftRule.grid.mstShiftRuleEachShiftDuration',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftRuleBeginTime',
        label: 'label.em.admin.imfMstLocationShiftRule.grid.mstShiftRuleBeginTime',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'beginDate',
        label: 'label.em.admin.imfMstLocationShiftRule.grid.beginDate',
        sortable: true,
        form: {
        type: 'datepicker'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstLocationShiftRule.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    mstLocationIdFilter : "",
    mstLocationNodeCodeStartsWithFilter : "",
    mstShiftRuleIdFilter : "",
    beginDateRteFilter : "",
    beginDateLteFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'mstLocationIdFilter',
        label: 'label.em.admin.imfMstLocationShiftRule.filter.mstLocationId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'mstShiftRuleIdFilter',
        label: 'label.em.admin.imfMstLocationShiftRule.filter.mstShiftRuleId',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'imfMstShiftRule'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'beginDateRteFilter',
        label: 'label.em.admin.imfMstLocationShiftRule.filter.beginDateRte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        },
        {
        key: 'beginDateLteFilter',
        label: 'label.em.admin.imfMstLocationShiftRule.filter.beginDateLte',
        disabled: false,
        form: {
        type: 'datepicker'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'mstLocationId',
        label: 'label.em.admin.imfMstLocationShiftRule.entity.mstLocationId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'imfMstLocation'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'mstShiftRuleId',
        label: 'label.em.admin.imfMstLocationShiftRule.entity.mstShiftRuleId',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,required: true
            ,entity: 'imfMstShiftRule'
            ,correspondingField: 'id'
                }
        },
        {
        key: 'beginDate',
        label: 'label.em.admin.imfMstLocationShiftRule.entity.beginDate',
        sortable: true,
        disabled: false,
        form: {
        type: 'datepicker'
            ,required: true
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstLocationShiftRule.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {ImfMstLocationShiftRule, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
